<p class="d-block">{{ step1.getspan1 | translate}}</p>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="fnSimpleAttribution.avisInitial.idWeb"
	[label]="step1.idWeb" [type]="'text'" 
	[rule]="'pattern_9|required'"
	[errorMessage]="{'pattern' : 'ctr_pattern9'}"
	[name]="getUidAvisInitial() + '_SepAtt_idWeb'">
</app-form-input>

<app-form-input [parentForm]="parentForm" [disabled]="disabled"
	[value]="fnSimpleAttribution.avisInitial.datePublication" [label]="step1.datePublication" [type]="'date'"
	[rule]="''" [name]="getUidAvisInitial() + '_SepAtt_datePublication'">
</app-form-input>
